import logger from "redux-logger";

export const FETCH_PATIENTINVOICEDETAILS_INIT_ACTION =
  "FETCH_PATIENTINVOICEDETAILS_INIT_ACTION";
export const FETCH_PATIENTINVOICEDETAILS_SUCCESS_ACTION =
  FETCH_PATIENTINVOICEDETAILS_INIT_ACTION + "_SUCCESS";
export const FETCH_PATIENTINVOICEDETAILS_FAIL_ACTION =
  FETCH_PATIENTINVOICEDETAILS_INIT_ACTION + "_ERROR";

export const FETCH_PATIENTINVOICESTATUSCHANGE_INIT_ACTION =
  "FETCH_PATIENTINVOICESTATUSCHANGE_INIT_ACTION";
export const FETCH_PATIENTINVOICESTATUSCHANGE_SUCCESS_ACTION =
  FETCH_PATIENTINVOICESTATUSCHANGE_INIT_ACTION + "_SUCCESS";
export const FETCH_PATIENTINVOICESTATUSCHANGE_FAIL_ACTION =
  FETCH_PATIENTINVOICESTATUSCHANGE_INIT_ACTION + "_ERROR";

export function PatientInvoiceList(value) {
  return {
    type: FETCH_PATIENTINVOICEDETAILS_INIT_ACTION,
    value:value
  };
}

export function PatientInvoiceSelectedPage(value) {
  return {
    type: FETCH_PATIENTINVOICEDETAILS_INIT_ACTION,
    value: value
  };
}

export function PatientInvoiceStatusChange(value) {
  return {
    type: FETCH_PATIENTINVOICESTATUSCHANGE_INIT_ACTION,
    value: value
  };
}
